import { DefaultState } from 'store/types';

export const SET_DEFAULT_RESERVATION_PROVIDER_REQUEST = 'SET_DEFAULT_RESERVATION_PROVIDER_REQUEST';
export const SET_DEFAULT_RESERVATION_PROVIDER_SUCCESS = 'SET_DEFAULT_RESERVATION_PROVIDER_SUCCESS';
export const SET_DEFAULT_RESERVATION_PROVIDER_FAILURE = 'SET_DEFAULT_RESERVATION_PROVIDER_FAILURE';

export interface SetDefaultReservationProviderData {
  success: boolean;
}

export type SetDefaultReservationProviderState = DefaultState & {
  contents?: SetDefaultReservationProviderData;
};

interface SetDefaultReservationProviderRequest {
  type: typeof SET_DEFAULT_RESERVATION_PROVIDER_REQUEST;
}

interface SetDefaultReservationProviderSuccess {
  type: typeof SET_DEFAULT_RESERVATION_PROVIDER_SUCCESS;
  contents: SetDefaultReservationProviderData;
}

interface SetDefaultReservationProviderFailure {
  type: typeof SET_DEFAULT_RESERVATION_PROVIDER_FAILURE;
}

export type SetDefaultReservationProviderActionTypes = SetDefaultReservationProviderRequest | SetDefaultReservationProviderSuccess | SetDefaultReservationProviderFailure;